// extracted by mini-css-extract-plugin
export default {"btop":"_357ed73e9e e302603714 _84e0dade59","icon":"cbc4d7b658 f79d4d0197","btoppink":"_2ca5f404af f5ac5ffac4"};